import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

function Categories({ options, value, onChange, name }) {
  const handleOnClick = (v) => () => {
    onChange((prevState) => ({
      ...prevState,
      [name]: v,
    }));
  };

  return (
    <div className="flex items-center">
      {options?.filter((item) => item?.label)?.length > 0 ? (
        [
          {
            label: 'All Products',
            value: '',
          },
          ...options,
        ]?.map((item, key) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={key}
            className={cn(
              'p-2 px-2.5 lg:p-2.5 lg:px-3 font-semibold text-gray-400 rounded flex-shrink-0 cursor-pointer text-xs lg:text-sm',
              {
                '!text-white bg-primary-500':
                  value?.value === item?.value ||
                  (!value?.value && !item?.value),
              }
            )}
            onClick={handleOnClick(item)}
            role="presentation"
          >
            {item?.label}
          </div>
        ))
      ) : (
        <div className="text-lg -mb-1.5 pt-1 pl-1 font-bold text-gray-700">
          All Products
        </div>
      )}
    </div>
  );
}

Categories.defaultProps = {
  options: {},
  value: {},
  onChange: () => {},
};

Categories.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(Object),
  value: PropTypes.instanceOf(Object),
  onChange: PropTypes.instanceOf(Object),
};

export default Categories;
